import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { PageLayoutTabs } from '@thinknet-gmbh/platform-common-ui';

import { ROUTES } from 'src/components/app/app-routes.constants';
import { useRouteQuery } from 'src/common/helpers';

import { TASKS_SUB_PAGES } from './task-manager.constants';
import { getDefaultTab } from './task-manager.helpers';
import { TaskList } from './sub-pages/task-list';

const TaskManager: React.FC = () => {
  const { t } = useTranslation('processBuilder');
  const navigate = useNavigate();
  const query = useRouteQuery();
  const type: string = query.get('type') || '';

  return (
    <PageLayoutTabs
      pageTitle={t('tasks.labels.taskManager')}
      onTabChange={tab => navigate(`${ROUTES.taskManager}?type=${tab}`)}
      defaultTab={getDefaultTab(type)}
      elements={[
        {
          tab: t('labels.tasks'),
          tabIndex: TASKS_SUB_PAGES.tasks,
          component: <TaskList/>
        }
      ]}
    />
  );
};

export default TaskManager;
